import { Nav, NavItem } from 'react-bootstrap'

interface IProps {
    activeKey: string
}

const GpsContainerNav = (props: IProps) => {
    return (
        <Nav bsStyle='tabs' activeKey={props.activeKey}>
            <NavItem eventKey={'GPS-TRACKING'} href='/admin/gps/pend-gps-assign'>GPS Tracking</NavItem>
            <NavItem eventKey={'GPS-DEVICES'} href='/admin/gps/devices'>GPS Devices</NavItem>
        </Nav>
    );
}

export default GpsContainerNav;